/** Simple outline icons for the install steps. Decorative: the step text carries the meaning. */

const COMMON = {
  width: 24,
  height: 24,
  viewBox: '0 0 24 24',
  fill: 'none',
  stroke: 'currentColor',
  strokeWidth: 1.75,
  strokeLinecap: 'round',
  strokeLinejoin: 'round',
  'aria-hidden': true,
  focusable: false,
} as const

/** Safari's Share button: a box open at the top with an arrow rising from it. */
export function ShareIcon() {
  return (
    <svg {...COMMON}>
      <path d="M12 3v12" />
      <path d="M8 7l4-4 4 4" />
      <path d="M8 11H6.5A1.5 1.5 0 0 0 5 12.5v6A1.5 1.5 0 0 0 6.5 20h11a1.5 1.5 0 0 0 1.5-1.5v-6a1.5 1.5 0 0 0-1.5-1.5H16" />
    </svg>
  )
}

/** Chrome's menu on Android: three dots stacked. */
export function MenuDotsIcon() {
  return (
    <svg {...COMMON}>
      <circle cx="12" cy="5.5" r="1" />
      <circle cx="12" cy="12" r="1" />
      <circle cx="12" cy="18.5" r="1" />
    </svg>
  )
}

/** A bookmark ribbon. */
export function BookmarkIcon() {
  return (
    <svg {...COMMON}>
      <path d="M7 3.5h10a1 1 0 0 1 1 1V20l-6-4-6 4V4.5a1 1 0 0 1 1-1z" />
    </svg>
  )
}

/** A computer: a screen on a stand. */
export function DesktopIcon() {
  return (
    <svg {...COMMON}>
      <rect x="3" y="4" width="18" height="12" rx="2" />
      <path d="M8 20h8" />
      <path d="M12 16v4" />
    </svg>
  )
}

/** "Add to Home Screen": a rounded square with a plus. */
export function AddToHomeIcon() {
  return (
    <svg {...COMMON}>
      <rect x="4" y="4" width="16" height="16" rx="3.5" />
      <path d="M12 8.5v7" />
      <path d="M8.5 12h7" />
    </svg>
  )
}
